export function getSupabasePublicKey() {
    const publicKey = process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY;

    if (!publicKey) {
        throw new Error("A Supabase publishable key is required.");
    }

    return publicKey;
}
